import { render, staticRenderFns } from "./PendingSearch.vue?vue&type=template&id=30b3d612&"
import script from "./PendingSearch.vue?vue&type=script&lang=js&"
export * from "./PendingSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports